export default __webpack_public_path__ + "static/media/visa_mastercard_amex.f1baf9d7.png";